module.exports = __webpack_public_path__ + "img/10.e62b317a.jpg";